var exports = {
  "lm": "LanguageTab.module__notice___UHFYak",
  "ut": "LanguageTab.module__noticeText___UHFYak",
  "nf": "LanguageTab.module__link___UHFYak",
  "XG": "LanguageTab.module__languageSelect___UHFYak",
  "pK": "LanguageTab.module__languageControls___UHFYak",
  "e5": "LanguageTab.module__timeControls___UHFYak",
  "_9": "LanguageTab.module__languageOption___UHFYak",
  "Ri": "LanguageTab.module__languageOptionMenu___UHFYak",
  "l5": "LanguageTab.module__languageDetails___UHFYak",
  "aX": "LanguageTab.module__languageCode___UHFYak",
  "Eb": "LanguageTab.module__flagImage___UHFYak",
  "TU": "LanguageTab.module__flagImageText___UHFYak",
  "hx": "LanguageTab.module__languageOptionCompact___UHFYak",
  "cL": "LanguageTab.module__languageName___UHFYak",
  "X6": "LanguageTab.module__languageOptionSelected___UHFYak",
  "rv": "LanguageTab.module__tooltipContent___UHFYak",
  "HE": "LanguageTab.module__tooltipText___UHFYak",
  "QT": "LanguageTab.module__switchWrapper___UHFYak",
  "Kx": "LanguageTab.module__spellcheckHint___UHFYak",
  "OO": "LanguageTab.module__spellcheckRestartBanner___UHFYak",
  "Ru": "LanguageTab.module__dictionaryGrid___UHFYak",
  "b": "LanguageTab.module__dictionaryRow___UHFYak",
  "CG": "LanguageTab.module__dictionaryRowChecked___UHFYak",
  "mj": "LanguageTab.module__dictionaryName___UHFYak",
  "P": "LanguageTab.module__dictionaryTag___UHFYak",
  "Wc": "LanguageTab.module__manualDictionaryBlock___UHFYak",
  "uW": "LanguageTab.module__personalDictAddRow___UHFYak",
  "bU": "LanguageTab.module__personalDictInput___UHFYak",
  "rj": "LanguageTab.module__personalDictList___UHFYak",
  "ze": "LanguageTab.module__personalDictChip___UHFYak",
  "nm": "LanguageTab.module__personalDictChipRemove___UHFYak",
  "ib": "LanguageTab.module__personalDictEmpty___UHFYak",
};

module.exports = exports;
